export default "__VITE_ASSET__DaVDm1is__"